// Ruoli del consiglio direttivo (TASK #2), con i colori delle pill del prototipo.
//
// `DIRECTOR` ("Direttore") non è più assegnabile ma resta qui per dare un'etichetta
// ai record storici che lo usano: senza, in elenco uscirebbe il codice grezzo.
export const RUOLI_CONSIGLIO = [
	{ value: 'PRESIDENT', label: 'Presidente', pill: 'sid-pill--orange' },
	{ value: 'VICE_PRESIDENT', label: 'Vice presidente', pill: 'sid-pill--amber' },
	{ value: 'SECRETARY', label: 'Segretario', pill: 'sid-pill--blue' },
	{ value: 'TREASURER', label: 'Tesoriere', pill: 'sid-pill--green' },
	{ value: 'COUNCILLOR', label: 'Consigliere', pill: 'sid-pill--gray' },
	{ value: 'SAFEGUARD', label: 'Safeguard', pill: 'sid-pill--red' }
];

const STORICI = {
	DIRECTOR: { label: 'Direttore', pill: 'sid-pill--gray' }
};

export const ruoloConsiglio = (value) =>
	RUOLI_CONSIGLIO.find(r => r.value === value) || STORICI[value] || { label: value || '—', pill: 'sid-pill--gray' };
